import { Section, Img, Row, Column, Text, Link } from "@react-email/components";
import React from "react";

const footerImages = [
	{
		src: "https://offcutshades.com/images/email/madetolasticon.png",
		alt: "Made to last",
	},
	{
		src: "https://offcutshades.com/images/email/readytoshipicon.png",
		alt: "Ready to ship in 2 days",
	},
	{
		src: "https://offcutshades.com/images/email/guaranteeiconorange.png",
		alt: "Guaranteed fit",
	},
	{
		src: "https://offcutshades.com/images/email/pricerighticon.png",
		alt: "Price right every day",
	},
];

const socialLinks = [
	{
		link: "https://www.facebook.com/OffCutShadesOnline/",
		icon: "https://offcutshades.com/images/email/facebook-logo-black.png",
		alt: "Facebook",
	},
	{
		link: "https://www.instagram.com/offcutshades/",
		icon: "https://offcutshades.com/images/email/instagram-logo-black.png",
		alt: "Instagram",
	},
];

const styles = {
	section: {
		width: "100%",
		backgroundColor: "#efefef",
		padding: "20px",
		paddingBottom: "60px",
	},
	footerColumn: {
		width: `${100 / footerImages.length}%`,
		verticalAlign: "text-top",
	},
	center: {
		margin: "0 auto",
		textAlign: "center",
		display: "block",
	},
	socialIcon: {
		width: "40px",
		height: "40px",
		margin: "20px 30px",
	},
	telLink: {
		color: "initial",
		textDecoration: "underline",
		marginLeft: "5px",
	},
	storeLocation: { margin: "0", fontSize: "0.8rem" },
	signature: { padding: "30px 0" },
};

function FooterBadges() {
	return (
		<>
			<Row>
				{footerImages.map((image, i) => (
					<Column style={styles.footerColumn}>
						<Img
							key={i}
							src={image.src}
							alt={image.alt}
							title={image.alt}
							width={30}
							style={styles.center}
						/>
					</Column>
				))}
			</Row>
			<Row>
				{footerImages.map((image, i) => (
					<Column style={styles.footerColumn}>
						<Text key={i}>{image.alt}</Text>
					</Column>
				))}
			</Row>
		</>
	);
}

export function FooterSocialLinks() {
	return (
		<Row>
			{socialLinks.map((social) => (
				<Column>
					<Link href={social.link} title={social.alt} style={styles.socialIcon}>
						<Img src={social.icon} alt={social.alt} style={styles.center} />
					</Link>
				</Column>
			))}
		</Row>
	);
}

function FooterStoreAddress({ isInEmailList }) {
	return (
		<>
			<Row>
				<Text style={styles.storeLocation}>Off Cut Shades</Text>
			</Row>

			<Row>
				<Text style={styles.storeLocation}>
					50 Hollinger road, Toronto, ON ·
					<Link href="tel:+14162856001" style={styles.telLink}>
						416.285.6001
					</Link>
				</Text>
			</Row>
			{isInEmailList ? (
				<Row>
					<Text style={styles.storeLocation}>
						You are receiving this email because you have subscribed to Off Cut
						Shades email list.
					</Text>
				</Row>
			) : null}
		</>
	);
}

function CEOSignature() {
	return (
		<div style={styles.signature}>
			<Img
				src="https://offcutshades.com/images/email/zachsignature.jpg"
				alt="President and CEO Signature"
				width={200}
				style={styles.center}
			/>
		</div>
	);
}

export default function Footer({
	withCEOSignature,
	isInEmailList,
	utm_campaign,
}) {
	return (
		<footer>
			{withCEOSignature ? <CEOSignature /> : null}
			<Section style={styles.section}>
				<FooterBadges />
				<br />
				<br />
				<Row>
					<Column>
						<b>Follow Us</b>
					</Column>
				</Row>
				<FooterSocialLinks />
				<FooterStoreAddress isInEmailList={isInEmailList} />
			</Section>
		</footer>
	);
}
